import { StoreScheduleListParams } from "../../view/Modules/StoreSchedule/StoreScheduleDataTypes";
import AxiosInstance from "../config/axiosInterceptor";
import { ContentApiRoutes } from "../../navigation/NavConstant";
import { MediaPlayListParams } from "../../view/Modules/Reports/ReportDataTypes";
import { UtilityServices } from "./UtilityServices";
import { messageTypeArr } from "../config/AppConstants";

export const ReportServices = {
  getMediaPlayReport: (params: MediaPlayListParams) => {
    return AxiosInstance.get(ContentApiRoutes.MEDIA_PLAY_REPORT, { params });
  },
  exportMediaPlayReport: (params: MediaPlayListParams) => {
    return AxiosInstance.get(ContentApiRoutes.EXPORT_MEDIA_PLAY_REPORT, {
      params,
      responseType: "blob", // important
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "media-report-export.xls");
        document.body.appendChild(link);
        link.click();
      })
      .catch((response: any) => {
        UtilityServices.showToaster({
          message: "Some Technical Error Occured or Export Limit Exceeds",
          type: messageTypeArr.error,
        });
      });
  },
};
